import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  FiFacebook,
  FiInstagram,
  FiLinkedin,
  FiMail,
  FiMapPin,
  FiPhone,
  FiSend,
  FiUser,
  FiYoutube,
} from "react-icons/fi";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {
  CONTACT_FORM_INITIAL_STATE,
  submitContactForm,
} from "../utils/contactForm";

const contactCards = [
  {
    icon: FiMail,
    title: "Email Us",
    primary: "support@instaportdelivery.com",
    secondary: "We typically reply within\na few minutes",
    href: "mailto:support@instaportdelivery.com",
  },
  {
    icon: FiPhone,
    title: "Call Us",
    primary: "+91 88501 66601",
    secondary: "Mon - Sat: 10:00 AM - 8:00 PM\nSun: 10:00 AM - 6:00 PM",
    href: "tel:8850166601",
  },
  {
    icon: FiMapPin,
    title: "Visit Us",
    primary:
      "R/3 A Wing ground floor Mass\nMetropolis Chembur Mumbai\nMaharashtra 400071",
    secondary: "We'd love to meet you!",
  },
];

const socialLinks = [
  {
    icon: FiFacebook,
    label: "Facebook",
    href: "https://www.facebook.com/people/instaportdelivery/61590141218960/",
    color: "text-[#1877F2]",
  },
  {
    icon: FiInstagram,
    label: "Instagram",
    href: "https://www.instagram.com/instaportdelivery",
    color: "text-[#ff3f94]",
  },
  {
    icon: FiYoutube,
    label: "YouTube",
    href: "#",
    color: "text-[#ff0000]",
  },
  {
    icon: FiLinkedin,
    label: "LinkedIn",
    href: "#",
    color: "text-[#0A66C2]",
  },
];

const AboutUs = () => {
  const [formData, setFormData] = useState({ ...CONTACT_FORM_INITIAL_STATE });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const nextValue =
      name === "mobile" ? value.replace(/\D/g, "").slice(0, 10) : value;
    const nextMessage =
      name === "message" ? value.split(/\s+/).slice(0, 200).join(" ") : nextValue;

    setFormData((prev) => ({
      ...prev,
      [name]: name === "message" ? nextMessage : nextValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{10}$/.test(formData.mobile)) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }

    try {
      const res = await submitContactForm(formData, "contact");
      toast.success(res.data.message || "Message sent successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
      setFormData({ ...CONTACT_FORM_INITIAL_STATE });
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to send message", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <section className="min-h-screen w-screen overflow-x-hidden bg-[linear-gradient(180deg,#fdf8ee_0%,#fffdf8_22%,#fff9ef_100%)] text-[#1d2433]">
      <div className="flex min-h-screen w-full flex-col px-0 pb-4 pt-3 sm:pt-4">
        <Navbar />

        <div className="mt-3 w-full overflow-hidden rounded-[32px] bg-[linear-gradient(135deg,#fffefb_0%,#fffdf8_28%,#fff7e8_58%,#fffdf8_100%)] shadow-[0_24px_70px_rgba(177,146,90,0.14)]">
          <div className="relative px-4 pb-8 pt-0 sm:px-6 lg:px-12">
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_28%_34%,rgba(255,210,95,0.18),rgba(255,255,255,0)_36%),radial-gradient(circle_at_60%_18%,rgba(255,220,150,0.14),rgba(255,255,255,0)_28%),radial-gradient(circle_at_82%_16%,rgba(255,201,79,0.14),rgba(255,255,255,0)_30%)]" />
            <div className="absolute left-6 top-12 grid grid-cols-4 gap-4 opacity-60">
              {Array.from({ length: 16 }).map((_, index) => (
                <span
                  key={index}
                  className="h-[4px] w-[4px] rounded-full bg-[#f4c257]"
                />
              ))}
            </div>

            <div className="relative z-10 overflow-hidden rounded-[28px] border border-[#efe5d2] bg-[linear-gradient(135deg,#fffefb_0%,#fffdf8_34%,#fff7ea_100%)] px-5 pb-8 pt-8 shadow-[0_18px_50px_rgba(177,146,90,0.10)] sm:px-8 lg:grid lg:grid-cols-[minmax(0,0.9fr)_minmax(400px,1.02fr)] lg:items-center lg:gap-8 lg:px-10 lg:pb-12 lg:pt-12">
              <div className="relative z-20 max-w-[560px]">
                <h1 className="max-w-[560px] text-[34px] font-extrabold leading-[1.05] tracking-[-0.045em] text-[#1d2739] sm:text-[46px] lg:text-[58px]">
                  Instaport
                  <span className="mt-2 block text-[#1c5e22]">
                    Customer Care &amp; Contact
                  </span>
                </h1>
                <div className="mt-8 h-[4px] w-[82px] rounded-full bg-[#f3b216]" />
                <p className="mt-6 max-w-[460px] text-[15px] leading-[1.8] text-[#4c5668] sm:text-[17px] lg:text-[18px]">
                  Have a courier booking question, delivery support request,
                  business delivery query, or feedback? Reach out to Instaport
                  Delivery and our team will respond as soon as possible.
                </p>
              </div>

              <div className="relative mt-8 min-h-[340px] overflow-hidden rounded-[24px] sm:min-h-[420px] lg:mt-0 lg:min-h-[560px]">
                <img
                  src="/assets/delivery_man_images/about_us_1.png"
                  alt="Instaport customer care executive"
                  className="absolute inset-0 h-full w-full object-cover object-[58%_10%] sm:object-[58%_12%] lg:object-[74%_10%]"
                />
                <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(255,252,244,0.98)_0%,rgba(255,251,241,0.74)_12%,rgba(255,249,238,0.28)_28%,rgba(255,248,236,0.06)_42%,rgba(255,248,236,0)_58%),linear-gradient(180deg,rgba(255,254,251,0.04)_0%,rgba(255,254,251,0)_14%,rgba(255,247,235,0.16)_100%)]" />
                <div className="absolute left-0 top-0 h-full w-14 sm:w-20 bg-[linear-gradient(90deg,#fffdf8_0%,rgba(255,253,248,0)_100%)]" />
                <div className="absolute bottom-0 left-0 right-0 h-12 sm:h-16 bg-[linear-gradient(0deg,#fff8ed_0%,rgba(255,248,237,0)_100%)]" />
              </div>
            </div>

            <div className="relative z-20 mt-6 grid gap-4 lg:grid-cols-3 lg:gap-5">
              {contactCards.map(({ icon: Icon, title, primary, secondary, href }) => (
                <div
                  key={title}
                  className="rounded-[24px] bg-white px-6 py-8 text-center shadow-[0_18px_45px_rgba(191,166,116,0.18)] lg:rounded-[28px] lg:px-10 lg:py-10"
                >
                  <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[linear-gradient(180deg,#ffb321_0%,#ff9800_100%)] text-[30px] text-white shadow-[0_12px_28px_rgba(255,170,0,0.24)]">
                    <Icon />
                  </div>
                  <h3 className="mt-5 text-[21px] font-semibold text-[#1e2430] lg:mt-7 lg:text-[24px]">
                    {title}
                  </h3>
                  {href ? (
                    <a
                      href={href}
                      className="mt-4 block whitespace-pre-line text-[16px] font-semibold leading-[1.6] text-[#262d38] lg:mt-5 lg:text-[18px]"
                    >
                      {primary}
                    </a>
                  ) : (
                    <p className="mt-4 whitespace-pre-line text-[16px] font-semibold leading-[1.6] text-[#262d38] lg:mt-5 lg:text-[18px]">
                      {primary}
                    </p>
                  )}
                  <p className="mt-5 whitespace-pre-line text-[15px] leading-[1.6] text-[#687283] lg:mt-6 lg:text-[16px]">
                    {secondary}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-12 grid gap-0 overflow-hidden rounded-[28px] bg-white shadow-[0_18px_55px_rgba(186,157,106,0.16)] lg:mt-16 lg:grid-cols-[41%_59%] lg:rounded-[34px]">
              <div className="relative h-[300px] overflow-hidden sm:h-[420px] lg:min-h-[760px] lg:h-auto">
                <img
                  src="/assets/delivery_man_images/about_us_2.png"
                  alt="Instaport support executive"
                  className="h-full w-full object-cover object-[center_18%] sm:object-[center_14%] lg:object-center"
                />
              </div>

              <div className="relative bg-[radial-gradient(circle_at_top,_#ffffff_0%,_#fffdf8_46%,_#fff5e5_100%)] px-5 py-8 sm:px-8 lg:px-14 lg:py-12">
                <div className="absolute right-10 top-10 grid grid-cols-4 gap-3 opacity-60">
                  {Array.from({ length: 16 }).map((_, index) => (
                    <span
                      key={index}
                      className="h-[4px] w-[4px] rounded-full bg-[#f4c257]"
                    />
                  ))}
                </div>

                <div className="max-w-[700px]">
                  <h2 className="text-[34px] font-extrabold leading-[1.08] tracking-[-0.04em] text-[#1d2739] sm:text-[46px] lg:text-[62px]">
                    Send Us a <span className="text-[#ff9b00]">Message</span>
                  </h2>
                  <p className="mt-4 max-w-[520px] text-[15px] leading-[1.8] text-[#667186] sm:text-[17px] lg:mt-5 lg:text-[18px]">
                    Fill out the form below and our team will get back to you
                    within 24 hours.
                  </p>

                  <form
                    onSubmit={handleSubmit}
                    className="mt-8 rounded-[24px] border border-[#efe6d4] bg-white p-5 shadow-[0_16px_40px_rgba(201,176,109,0.10)] sm:p-6 lg:mt-10 lg:rounded-[30px] lg:p-8"
                  >
                    <div className="space-y-4">
                      <div className="flex h-[66px] items-center gap-4 rounded-[16px] border border-[#e7e0d4] px-5">
                        <FiUser className="text-[20px] text-[#80889c]" />
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Your Full Name"
                          className="h-full w-full border-none bg-transparent text-[18px] text-[#1f2630] outline-none placeholder:text-[#8f97a8]"
                          required
                        />
                      </div>

                      <div className="flex h-[66px] items-center gap-4 rounded-[16px] border border-[#e7e0d4] px-5">
                        <FiMail className="text-[20px] text-[#80889c]" />
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Your Email Address"
                          className="h-full w-full border-none bg-transparent text-[18px] text-[#1f2630] outline-none placeholder:text-[#8f97a8]"
                          required
                        />
                      </div>

                      <div className="flex h-[66px] items-center gap-4 rounded-[16px] border border-[#e7e0d4] px-5">
                        <FiPhone className="text-[20px] text-[#80889c]" />
                        <input
                          type="tel"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          placeholder="Your Mobile Number"
                          inputMode="numeric"
                          maxLength={10}
                          pattern="\d{10}"
                          className="h-full w-full border-none bg-transparent text-[18px] text-[#1f2630] outline-none placeholder:text-[#8f97a8]"
                          required
                        />
                      </div>

                      <div className="rounded-[16px] border border-[#e7e0d4] px-5 py-4">
                        <div className="flex items-start gap-4">
                          <FiSend className="mt-1 text-[20px] text-[#80889c]" />
                          <div className="w-full">
                            <textarea
                              name="message"
                              value={formData.message}
                              onChange={handleChange}
                              placeholder="Write your message (max 200 words)"
                              maxLength={200}
                              rows={5}
                              className="w-full resize-none border-none bg-transparent text-[18px] text-[#1f2630] outline-none placeholder:text-[#8f97a8]"
                              required
                            />
                            <p className="mt-3 text-right text-[15px] text-[#7e8797]">
                              {formData.message.length}/200
                            </p>
                          </div>
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="flex h-[58px] w-full items-center justify-center gap-3 rounded-[14px] bg-[linear-gradient(180deg,#ff9d00_0%,#ff7c00_100%)] text-[18px] font-semibold text-white shadow-[0_14px_30px_rgba(255,146,0,0.25)] transition hover:brightness-105 sm:h-[64px] sm:text-[20px] lg:h-[68px] lg:text-[24px]"
                      >
                        <FiSend className="text-[20px]" />
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="mt-14 text-center">
              <h3 className="text-[24px] font-semibold text-[#202737] lg:text-[30px]">
                Connect With Us
              </h3>
              <div className="mt-8 flex flex-wrap justify-center gap-5 lg:gap-8">
                {socialLinks.map(({ icon: Icon, label, href, color }) => {
                  const disabled = href === "#";
                  const commonClassName =
                    "flex h-16 w-16 items-center justify-center rounded-full bg-white text-[28px] shadow-[0_12px_28px_rgba(191,166,116,0.16)] transition";

                  if (disabled) {
                    return (
                      <button
                        key={label}
                        type="button"
                        disabled
                        aria-label={label}
                        className={`${commonClassName} ${color} cursor-not-allowed opacity-70`}
                      >
                        <Icon />
                      </button>
                    );
                  }

                  return (
                    <a
                      key={label}
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={label}
                      className={`${commonClassName} ${color} hover:-translate-y-1`}
                    >
                      <Icon />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="mt-8 overflow-hidden rounded-t-[32px] bg-white shadow-[0_-10px_30px_rgba(177,146,90,0.05)]">
            <Footer />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
